var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#CAD3C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6875 17H32.25V20.375H55.3125V58.625H43.5V50.1875H36.1875V58.625H24.375V20.375H29.4375V17H21V20.375V58.625V62H24.375H36.1875H43.5H55.3125H58.6875V58.625V20.375V17ZM41.8125 25.4375H37.875V30.5H32.8125V34.4375H37.875V39.5H41.8125V34.4375H46.875V30.5H41.8125V25.4375Z",
    fill: "#E0EAD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePlus);
export default __webpack_public_path__ + "static/media/onePlus.365c05e35409d7af85a8387452104445.svg";
export { ForwardRef as ReactComponent };